<template>
  <div class="holder pt-1 mr-2">
    <router-link :to="'/music/' + book.title.replace(/ /g, '-')">
      <img :src="book.itemImage" class="ma-2 mr-3" />
    </router-link>
    <h4 class="mt-1">{{ book.title }}</h4>
    <div>{{ book.subtitle }}</div>
    <p class="mr-2" v-html="book.short_description"></p>
    <v-btn
      class="button"
      :to="/music/ + book.title.replace(/ /g, '-')"
      color="info"
    >
    <div>View</div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "MusicSelectionItem",
  props: {
      book: Object
  }  
};
</script>

<style scoped>
.button {
  float: right;
}

img{
    width: 150px;
    float:left;
    margin:auto;
}

h4{
    display:block;
}

p >>> p{
    font-size: 11px;
}

p{    
    display: inline;
    height: 120px;
    max-height: 120px;
}

v-btn{
    margin:auto;
    margin-bottom: 2px;
}
</style>